export const normalize = (value) => String(value ?? '').replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
export function resolveSearch(query, requestedMode, pathname) {
  const mode = requestedMode === 'auto' ?
    (/\b(where|enter|input|dropdown|drop down|available|find (?:a |the )?field)\b/i.test(query) ? 'fields' : 'job') : requestedMode;
  const requestedJob = query.match(/\bjob\s*(?:number\s*)?(\d+)\b/i)?.[1];
  const currentJob = pathname.match(/^\/(\d+)(?:\/|$)/)?.[1];
  const error = '';
  const term = normalize(query.replace(/\bjob\s*(?:number\s*)?\d+\b/ig, ''))
    .split(' ').filter((word) => !new Set(['where', 'does', 'do', 'the', 'a', 'an', 'go', 'goes', 'find', 'enter',
      'what', 'is', 'are', 'on', 'this', 'current', 'job', 'value', 'values', 'selected', 'for', 'of', 'how', 'i', 'can', 'in', 'have', 'has', 'any']).has(word)).join(' ');
  return { mode, term, error, jobId: currentJob, requestedJob };
}
export const roleAllowed = (allowed, roles) => !allowed.length || allowed.some((r) => roles.includes(r));
export function pathMatches(pattern, pathname) {
  if (pattern === '*') return true;
  const parts = pattern.replace(/\/+$/, '').split('/');
  const actual = pathname.replace(/\/+$/, '').split('/');
  return parts.every((part, i) => part === '*' || (part.startsWith(':') ? Boolean(actual[i]) : part.toLowerCase() === actual[i]?.toLowerCase())) &&
    (parts[parts.length - 1] === '*' || parts.length === actual.length);
}
export function helpAllowed(config, pathname, roles) {
  if (!config.enabled || !roleAllowed(config.roles, roles)) return false;
  // All matching rules must allow access; a broad deny cannot be bypassed by a narrow allow.
  return config.pageRules.filter((r) => pathMatches(r.page, pathname))
    .every((r) => r.enabled && roleAllowed(r.roles, roles));
}
export function validateConfig(value) {
  const strings = (v) => Array.isArray(v) && v.every((s) => typeof s === 'string' && s.length < 160);
  const page = (v) => typeof v === 'string' && (v === '*' || /^\/[a-zA-Z0-9/:_*-]*$/.test(v)) &&
    v.length < 200 && !v.slice(0, -1).includes('*');
  if (!value || value.version !== 1 || typeof value.enabled !== 'boolean' || !strings(value.roles) ||
    !Array.isArray(value.pageRules) || value.pageRules.length > 200 ||
    !value.pageRules.every((r) => r && page(r.page) && typeof r.enabled === 'boolean' && strings(r.roles)) ||
    !Array.isArray(value.articles) || value.articles.length > 200 ||
    !value.articles.every((a) => a && typeof a.id === 'string' && a.id.length < 160 &&
      typeof a.title === 'string' && a.title.trim() && a.title.length < 200 && page(a.page) &&
      strings(a.roles) && typeof a.markdown === 'string' && a.markdown.length <= 100000) ||
    new Set(value.articles.map((a) => a.id)).size !== value.articles.length) {
    throw new Error('Invalid help package. Check version, page patterns, roles, and article sizes.');
  }
  return value;
}
export function searchFields(fields, options, query) {
  const terms = normalize(query).split(' ').filter(Boolean);
  if (!terms.length) return [];
  return fields.map((f) => {
    const choices = [...new Set(options.filter((o) => f.dropdowns.some((d) =>
      normalize(d) === normalize(o.DropdownType))).map((o) => o.DisplayText).filter((x) => typeof x === 'string'))];
    const text = normalize([f.label, f.control, f.area, f.component, ...f.fields, ...f.dropdowns, ...choices].join(' '));
    const matchedChoices = choices.filter((v) => terms.every((term) => normalize(v).includes(term)));
    return { ...f, matchedChoices, match: terms.every((t) => text.includes(t)),
      score: matchedChoices.length ? 3 : normalize(f.label).includes(normalize(query)) ? 2 : 1 };
  }).filter((f) => f.match).sort((a, b) => b.score - a.score || a.label.localeCompare(b.label));
}
